var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8020_8784)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8020_8784",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8020_8784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z",
    fill: "url(#paint0_linear_8020_8784)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9403 10.964C6.9161 11.1515 6.9161 11.3122 6.9161 11.4997H5.4628C5.4628 11.3122 5.4628 11.1515 5.4871 10.964H6.9403ZM12.6081 7.7498H11.8815C11.6877 7.7498 11.5181 7.9373 11.5181 8.1516V11.6604C11.5181 11.7675 11.5666 11.8747 11.615 11.955L13.6496 14.2049C13.7949 14.3657 14.0129 14.3657 14.1583 14.2049L14.6669 13.6425C14.8122 13.4818 14.8122 13.2407 14.6669 13.08L12.9714 11.1783V8.1516C12.9714 7.9373 12.8019 7.7498 12.6081 7.7498ZM12.2448 4C8.66 4 5.7293 7.0802 5.4871 10.964C5.4871 11.0444 5.4628 11.1515 5.4628 11.2318H4.3729C4.058 11.2318 3.8885 11.6336 4.0822 11.8747L5.8988 14.3121C6.0442 14.4996 6.3106 14.4996 6.4559 14.3121L8.2725 11.8747C8.4663 11.6068 8.2967 11.2318 7.9818 11.2318H6.9161V10.964C7.1583 7.9641 9.4593 5.6071 12.2206 5.6071C15.3693 5.6071 17.8641 8.6337 17.525 12.1693C17.2828 14.7139 15.1029 17.1245 12.7776 17.3655C11.0579 17.553 9.4351 16.8566 8.2967 15.4906C8.1514 15.3031 7.9576 15.196 7.7639 15.4638L7.1825 16.2406C7.0614 16.4013 7.1583 16.5084 7.2794 16.6423C8.5874 18.1691 10.3797 19.0262 12.3174 18.9994C15.8053 18.9458 18.7361 15.8924 18.9783 12.0354C19.2931 7.6695 16.1444 4 12.2448 4Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8020_8784",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8020_8784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecent);
export default __webpack_public_path__ + "static/media/Recent.558a8d45ba9ec54927966c1fb04bdcd7.svg";
export { ForwardRef as ReactComponent };